/**
 * Error thrown when fetch returns a non-200 response.
 */ class FetchError extends Error {
    constructor(response){
        super(`${response.status} ${response.statusText}`), this.response = response;
        Object.setPrototypeOf(this, FetchError.prototype);
    }
}
function isFetchError(error) {
    return error instanceof FetchError || error.message.match(/failed to fetch/i);
}

export { FetchError, isFetchError };
//# sourceMappingURL=FetchError.js.map
